import { useCallback, useState } from 'react';
import {
  INFO_EXPLAIN_DEFAULT_COLLISION_PADDING,
  readChromeCollisionPadding,
  type InfoExplainCollisionPadding,
} from './infoExplainPopoverChrome.js';

export type UseInfoExplainPopoverStateResult = {
  readonly open: boolean;
  readonly collisionPadding: InfoExplainCollisionPadding;
  readonly handleOpenChange: (nextOpen: boolean) => void;
};

/** Modal open state that refreshes chrome/safe-area collision padding on open. */
export function useInfoExplainPopoverState(): UseInfoExplainPopoverStateResult {
  const [open, setOpen] = useState(false);
  const [collisionPadding, setCollisionPadding] =
    useState<InfoExplainCollisionPadding>(
      () => INFO_EXPLAIN_DEFAULT_COLLISION_PADDING,
    );

  const handleOpenChange = useCallback((nextOpen: boolean): void => {
    if (nextOpen) {
      setCollisionPadding(readChromeCollisionPadding());
    }
    setOpen(nextOpen);
  }, []);

  return { open, collisionPadding, handleOpenChange };
}